"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconConvenienceApiServiceImpl = void 0;
const core_1 = require("@athena-portal/core");
const Types_1 = require("../../Types");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const Cache_1 = require("../../decorators/Cache");
/**
 * Rest implementation of the example service
 */
let FalconConvenienceApiServiceImpl = class FalconConvenienceApiServiceImpl extends core_1.RestService {
    constructor(configuration, notificationService) {
        super();
        this.configuration = configuration;
        this.notificationService = notificationService;
    }
    analyzeDriversLicenceFront(driversLicenceImage, quoteId) {
        const body = {
            image: driversLicenceImage
        };
        return this.doRequest(`/driver-licence-front?quoteId=${quoteId}`, "POST", body);
    }
    analyzeDriversLicenceBack(driversLicenceImage, quoteId) {
        const body = {
            image: driversLicenceImage
        };
        return this.doRequest(`/driver-licence-back?quoteId=${quoteId}`, "POST", body);
    }
    getRegistrationNumber(vehicleImage) {
        const body = {
            image: vehicleImage
        };
        return this.doRequest("/registration-number", "POST", body);
    }
    getAddressDetailsByPostcodeAndBuilding(partialAddress, limit, offset) {
        return this.doRequest(`/address-lookup-postcode-building?partialAddress=${partialAddress}&limit=${limit}&offset=${offset}`);
    }
    getEalsAddressDetailsByPostcodeAndBuilding(postcode, building) {
        return this.doRequest(`/eals-address-list?postcode=${postcode}&building=${building}`);
    }
    getEalsAddressDetails(addressDetails) {
        return this.doRequest(`/eals-address-details`, "POST", addressDetails);
    }
    getVehicleManufacturerDetails(partialVehicleManufacturer) {
        return this.doRequest(`/vehicle-manufacturer-lookup?partialVehicleManufacturer=${partialVehicleManufacturer}`);
    }
    getVehicleModelYears(vehicleManufacturer, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-model-years-annual?vehicleManufacturer=${vehicleManufacturer}&vehicleShortenedModel=${shortenedModel}`);
        }
        else {
            return this.doRequest(`/vehicle-model-years-annual?vehicleManufacturer=${vehicleManufacturer}`);
        }
    }
    getVehicleTransmissions(vehicleManufacturer, manufactureYear, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-transmissions-annual?vehicleManufacturer=${vehicleManufacturer}&manufactureYear=${manufactureYear}&vehicleShortenedModel=${shortenedModel}`);
        }
        else {
            return this.doRequest(`/vehicle-transmissions?vehicleManufacturer=${vehicleManufacturer}&manufactureYear=${manufactureYear}`);
        }
    }
    getVehicleFuelTypes(vehicleManufacturer, manufactureYear, transmission, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-fuel-types-annual?vehicleManufacturer=${vehicleManufacturer}&vehicleShortenedModel=${shortenedModel}&manufactureYear=${manufactureYear}&transmission=${transmission}`);
        }
        else {
            return this.doRequest(`/vehicle-fuel-types?vehicleManufacturer=${vehicleManufacturer}&manufactureYear=${manufactureYear}&transmission=${transmission}`);
        }
    }
    getVehicleEngineSizes(manufacturer, manufactureYear, transmission, fuelType) {
        return this.doRequest(`/vehicle-engine-sizes?vehicleManufacturer=${manufacturer}&manufactureYear=${manufactureYear}&transmission=${transmission}&fuelCode=${fuelType}`);
    }
    getVehicleDoors(manufacturer, manufactureYear, transmission, fuelType, engineSize, shortenedModel) {
        let queryParams = `vehicleManufacturer=${manufacturer}&manufactureYear=${manufactureYear}&transmission=${transmission}&fuelCode=${fuelType}`;
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        if (shortenedModel) {
            return this.doRequest(`/vehicle-doors-annual?${queryParams}&vehicleShortenedModel=${shortenedModel}`);
        }
        else {
            return this.doRequest(`/vehicle-doors?${queryParams}`);
        }
    }
    getVehicleStyles(manufacturer, manufactureYear, transmission, fuelType, engineSize, doors) {
        let queryParams = `vehicleManufacturer=${manufacturer}&manufactureYear=${manufactureYear}&transmission=${transmission}&fuelCode=${fuelType}&doors=${doors}`;
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        return this.doRequest(`/vehicle-styles?${queryParams}`);
    }
    getVehicleModelDetails(vehicleManufacturer, manufactureYear, transmission, fuelCode, partialVehicleModel) {
        return this.doRequest(`/vehicle-model-lookup?vehicleManufacturer=${vehicleManufacturer}&manufactureYear=${manufactureYear}&transmission=${transmission}&fuelCode=${fuelCode}&partialVehicleModel=${partialVehicleModel}`);
    }
    getAnnualVehicleShortenedModelDetails(manufacturer, shortenedModel) {
        let queryParams = `vehicleManufacturer=${manufacturer}&vehicleShortenedModel=${shortenedModel}`;
        return this.doRequest(`/vehicle-shortened-model-lookup-annual?${queryParams}`);
    }
    getAnnualVehicleModelDetails(manufacturer, manufactureYear, transmission, fuelType, engineSize, doors, style, shortenedModel, model) {
        let queryParams = `vehicleManufacturer=${manufacturer}&manufactureYear=${manufactureYear}` +
            `&transmission=${transmission}&fuelCode=${fuelType}&doors=${doors}&bodyStyle=${style}&vehicleShortenedModel=${shortenedModel}&partialVehicleModel=${model}`;
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        return this.doRequest(`/vehicle-model-lookup-annual?${queryParams}`);
    }
    postcodeExists(postcode) {
        return this.doRequest(`/postcode-lookup?postcode=${postcode}`);
    }
    getFurnishingTypeParams() {
        return this.doRequest(`/furnishing-types`);
    }
    getCustomerCancellationReasons(product) {
        return this.doRequest(`/customer-cancellation-reasons?product=${product}`);
    }
    getImages(reference) {
        return this.doRequest(`/images?reference=${reference}`);
    }
    deleteImage(reference, imageId) {
        return this.doRequest(`/images/${imageId}?reference=${reference}`, "DELETE");
    }
    deleteByReference(reference) {
        return this.doRequest(`/images?reference=${reference}`, "DELETE");
    }
    postImage(reference, base64, filename) {
        const body = {
            image: base64,
            filename: filename
        };
        return this.doRequest(`/images?reference=${reference}`, "POST", body);
    }
    getSettings() {
        return this.doRequest(`/settings`);
    }
    getAllProductClassifiers(product) {
        return this.doRequest(`/classifier/${product}/all`);
    }
    getClassifiers(classifierName, fieldValue) {
        let requestUrl = `/classifier/${classifierName}`;
        if (fieldValue !== undefined) {
            requestUrl = requestUrl.concat(`?fieldValue=${fieldValue}`);
        }
        return this.doRequest(requestUrl);
    }
    doRequest(urlAppend, method, body, onErrorReturn) {
        return super.getProtectedResource({
            body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters, false).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.of)(onErrorReturn || {});
        }));
    }
    addEngineSizeToQuery(queryParams, engineSize) {
        if (engineSize) {
            queryParams = queryParams + `&engineSize=${engineSize}`;
        }
        return queryParams;
    }
};
exports.FalconConvenienceApiServiceImpl = FalconConvenienceApiServiceImpl;
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getSettings", null);
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getAllProductClassifiers", null);
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getClassifiers", null);
exports.FalconConvenienceApiServiceImpl = FalconConvenienceApiServiceImpl = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(Types_1.Types.FalconConvenienceApiServiceConfig)),
    __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
    __metadata("design:paramtypes", [Object, Object])
], FalconConvenienceApiServiceImpl);
//# sourceMappingURL=FalconConvenienceApiServiceImpl.js.map